import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// import StaticBackend from './i18n-static-backend.js'; // do this if you need to revert to StaticBackend use.
import HybridBackend from './i18n-hybrid-backend.js';
import LanguageDetector from 'i18next-browser-languagedetector';
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
  // load translation using static imports instead of HTTP requests
  .use(HybridBackend)   // Replace with .use(StaticBackend) to avoid database loading all together.
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    // Configure language detection order - user preferences will override this later
    detection: {
      // Detection order: localStorage, navigator, htmlTag
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Cache user language preference
      caches: ['localStorage'],
      // Don't look in cookie or querystring
      lookupCookie: false,
      lookupQuerystring: false,
    },
  });

i18n.on('languageChanged', (language) => {
  // Set the html elements lang to match i18ns.
  // We are using this to tell Firefox to translate number inputs into the appropriate locale.
  document.documentElement.lang = i18n.resolvedLanguage || language || 'en';
});

document.documentElement.lang = i18n.resolvedLanguage || i18n.language || 'en';

export default i18n;
